module.exports = __webpack_public_path__ + "img/hr-carousel-background@2x.d55623f2.png";